<template>
  <router-view :key="$route.fullPath"></router-view>
  
</template>
<notifications group="foo" />
<script>
export default {
  name: 'app'
};
</script>

<style lang="scss">
.custom-checkbox .custom-control-label {
  position: relative;
  padding-left: 2rem; /* Adjust this to fit the size of your checkbox */
  cursor: pointer;
}
 
.custom-checkbox .custom-control-label::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 20px; /* Adjust the size of the checkbox */
  height: 20px;
  border: 2px solid #007bff; /* Border color */
  border-radius: 50% !important; /* Makes it circular */
  background-color: #fff; /* Background color */
}
 
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #007bff; /* Background color when checked */
  border-color: #007bff; /* Border color when checked */
}
 
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 5px; /* Adjust positioning of the checkmark */
  transform: translateY(-50%);
  width: 10px; /* Adjust size of the checkmark */
  height: 10px;
  border-radius: 50%; /* Checkmark shape */
  background-color: #fff; /* Checkmark color */
}
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import 'assets/scss/style';
  @import "../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";
@import "../node_modules/@syncfusion/ej2-buttons/styles/material.css";
  

</style>

